import React, { useState } from "react";
import styled from "styled-components";

const StyledElement = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: auto;

& .img-item {
    width: 1200px;
    cursor: pointer; /* 마우스 포인터를 핸드 모양으로 변경 */
}  
`;


export const BhHomepage10View = ({ viewNumber, imgLength }) => {
    const [activeImageIndex, setActiveImageIndex] = useState(null); // 한 번에 하나의 이미지만 'dn' 상태

  // 이미지 URL을 동적으로 설정 (viewNumber에 따라 다르게 설정)
  const imageUrls = Array.from({ length: imgLength }, (_, index) => `/image/10page_i_${viewNumber}_${index + 1}_up.png`);
  const selectedImageUrls = Array.from({ length: imgLength }, (_, index) => `/image/10page_i_${viewNumber}_${index + 1}_dn.png`);

    // 이미지 클릭 핸들러
    const handleImageClick = (index) => {
        setActiveImageIndex(index); // 클릭한 이미지의 index를 active로 설정
    };


    return (
        <StyledElement>
            {imageUrls.map((url, index) => {
                // 클릭된 이미지의 index와 비교하여 src URL을 결정
                const src = activeImageIndex === index ? selectedImageUrls[index] : url;

                return (
                    <img
                        key={index}
                        src={src}
                        alt={`view1-image-${index}`}
                        className="img-item"
                        onClick={() => handleImageClick(index)} // 클릭 시 해당 인덱스 업데이트
                    />
                );
            })}
        </StyledElement>
    );
};
